import dayjs, { Dayjs } from 'dayjs';

export const LOTTERY_ANCHOR = dayjs('2026-06-07'); // 복권 1회차 시작 일요일

function toSunday(d: Dayjs): Dayjs {
  return d.subtract(d.day(), 'day').startOf('day');
}

function firstLotterySundayOfMonth(year: number, month: number): Dayjs {
  const firstOfMonth = dayjs(new Date(year, month - 1, 1));
  const dow = firstOfMonth.day();
  const firstSunday = dow === 0 ? firstOfMonth : firstOfMonth.add(7 - dow, 'day');
  return firstSunday.isBefore(LOTTERY_ANCHOR) ? LOTTERY_ANCHOR : firstSunday;
}

export type LotteryInfo = { weekLabel: string; roundLabel: string; round: number };

export function getLotteryInfo(d: Dayjs): LotteryInfo | null {
  const weekSunday = toSunday(d);
  if (weekSunday.isBefore(LOTTERY_ANCHOR)) return null;

  const round = weekSunday.diff(LOTTERY_ANCHOR, 'week') + 1;
  const month = weekSunday.month() + 1;
  const year = weekSunday.year();
  const firstSunday = firstLotterySundayOfMonth(year, month);
  const weekOfMonth = weekSunday.diff(firstSunday, 'week') + 1;

  return {
    weekLabel: `${month}월 ${weekOfMonth}주차`,
    roundLabel: `복권 ${round}회차`,
    round,
  };
}
